import {
  ICustomer,
  ISearchCustomerRequest,
  IGetCustomerRequest,
  ISearchCustomerResponse,
  IInsertCustomerResponse,
  IUpdateCustomerResponse,
  IGetCustomerResponse,
  IFindEmailResponse,
} from "@/interfaces";
import { AxiosResponse } from "axios";
import Vue from "vue";

export const SearchCustomers = async (
  value: string,
  page: number,
  size: number,
	isActive: boolean = true
): Promise<ISearchCustomerResponse> => {
  const searcCustomersRequest: ISearchCustomerRequest = {
    Page: page,
		IsActive: isActive,
    PageSize: size,
    Keyword: value,
  };
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data: searcCustomersRequest,
    params: {
      action: "search-customer",
    },
  });
  return resp.data;
};

export const InsertCustomer = async (
  customer: ICustomer
): Promise<IInsertCustomerResponse> => {
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data: {
      Customer: customer,
    },
    params: {
      action: "insert-customer",
    },
  });
  return resp.data;
};

export const UpdatedCustomer = async (
  customer: ICustomer
): Promise<IUpdateCustomerResponse> => {
  const resp = await Vue.axios({
    method: "POST",
    data: {
      Customer: customer,
    },
    params: {
      action: "update-customer",
    },
  });
  return resp.data;
};

export const GetCustomer = async (
  id: number
): Promise<IGetCustomerResponse> => {
  const getCustomerRequest: IGetCustomerRequest = {
    CustomerID: id,
  };
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data: getCustomerRequest,
    params: {
      action: "get-customer",
    },
  });
  return resp.data;
};

export const FindEmail = async (value: string): Promise<IFindEmailResponse> => {
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data: {
      Key: value,
    },
    params: {
      action: "find-email",
    },
  });
  return resp.data;
};
